import React from 'react'

import {CapabilityRuntimeContext} from '@vio/core/src/_web/brand/hooks/CapabilityRuntimeContext'

import {useCapabilityContext} from '../hooks/useCapabilityContext'

interface CapabilityRuntimeProviderProps {
  children: React.ReactNode
}

/**
 * Bridges the atlas-aware `useCapabilityContext` producer (which lives in
 * `shared` and depends on `@vio/atlas`) with the in-core
 * `CapabilityRuntimeContext` consumed by `useBrandCapabilities`. Mount this
 * once near the top of every app shell, inside the `DeviceLayoutProvider`
 * and the Redux `Provider` (both inputs `useCapabilityContext` needs).
 *
 * Keeping the wrapper in `shared` lets every shell (client, checkout,
 * booking-management, partners) reuse the same wiring without each
 * re-deriving the runtime context.
 */
export const CapabilityRuntimeProvider = ({
  children
}: CapabilityRuntimeProviderProps) => {
  const value = useCapabilityContext()
  return (
    <CapabilityRuntimeContext.Provider value={value}>
      {children}
    </CapabilityRuntimeContext.Provider>
  )
}
